import api from '../../../App/socket';

export const updateTradeLead = (userId, leadId) => api.send({
    api: 'db',
    model: 'Lead',
    action: 'Update',
    options: {
        update: {
            ref_lead_status: '5f8574a3d88a9007b68aa732',
            'trade.is_trade': true,
            'trade.converted_by': userId,
            'trade.trade_created_date': new Date(),
        },
        where: {
            _id: leadId,
        },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/requests/assign_trade_lead_request.js